<template lang="pug">
  .component-translation
    .inner-content
      .row
        .column.shrink
          dropdown(:icon="'fa fa-ellipsis-v fa-2x action'", :position="'top'")
            TranslationButtons(:item="item")
        .column
          .label TR{{item.id}}
          .field {{item.id}}
        .column
          .label group
          .field {{item.group}}
        .column
          .label key
          .field {{item.key}}
        .column.cutMessage
          .label value
          .field  {{item.value}}
        .column.shrink.align-self-middle
          router-link(:to="{name:'translation', params:{id:item.id}}")
            i.fa.fa-angle-right.fa-3x.action
</template>

<script>


  import TranslationButtons from "../structure/ui/actions/TranslationButtons";
  import Dropdown from "../structure/foundation/Dropdown";
  export default {
    name: 'Translation',
    components: {Dropdown, TranslationButtons},
    props: ['item']
  }
</script>

<style lang="css">
.cutMessage {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}
</style>



// WEBPACK FOOTER //
// Translation.vue?c389ac0e